<template>
  <div>
    <section id="top-header">
      <div class="container">
        <div class="header-content">
          <div class="inner">
            <h1>Want some Appetizing Food?</h1>
            <h2>Grab yours now!</h2>

            <router-link to="/menu" tag="button" class="btn btn-lg btn-danger btn-fill">
              Browse the Menu
            </router-link>

            <p class="discount-text-header">Get a 10% discount using the code <strong>V21CU23</strong></p>
          </div>
        </div>
      </div>
      <div class="header-bg">
        <img src="../../assets/img/top-bg.jpg" alt="Kungfood background" />
        <div class="top-bg-separator"></div>
      </div>
    </section>

    <section id="featured-menu">
      <div class="container">
        <div class="text-center">
          <h2 class="section-title">Featured Menu</h2>
        </div>

        <div class="menu-items">
          <div class="row row-eq-height" v-if="products">
            <div v-for="product in products" class="animated zoomIn col-md-3 product-item" >
              <div class="card">
                <div class="image">
                  <img v-if="product.gallery.length" :src="base_url + '/' + product.gallery[0].image_path" :alt="product.title">
                  <img src="../../assets/img/food.png" v-else :alt="product.title">
                </div>
                <div class="content">
                  <h3 class="item-title">{{ product.title }}</h3>
                  <p class="item-category">
                    <small>{{product.category.title}}</small>
                  </p>
                  <p class="item-description">
                    {{ product.description }}
                  </p>

                  <div class="quantity">
                    <span class="q-add" @click="product.quantity++">+</span>
                    <span class="q-total">{{ product.quantity }}</span>
                    <span class="q-sub" @click="product.quantity > 1 ? product.quantity-- : product.quantity">-</span>
                  </div>

                  <br>
                  <div class="row align-items-center">
                    <div class="col-md-6 text-left">
                      <b-button class="btn-danger btn-sm" :disabled="!product.availability" @click="addToCart(product.title, product.code, product.gallery.length ? base_url + '/' + product.gallery[0].image_path : '', product.id, product.price, product.discount, product.quantity)"
                      >{{ product.availability ? 'Add to cart' : 'Out of stock' }}
                      </b-button>
                    </div>
                    <div class="col-md-6 text-right">
                      <span class="total-price has-discount" v-if="product.discount > 0">
                        <span class="old-price">£{{ product.price.toFixed(2) }}</span>
                        <span class="discount">£{{ product.discount.toFixed(2) }}</span>
                      </span>
                      <span class="total-price" v-else>
                        £ {{ product.price.toFixed(2) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="products.length == 0" class="text-center">
              There are no featured products to display. Check Menu page.
            </div>
          </div>
          <div class="row" v-if="!products">
            <div class="col-md-12 text-center">
              <div class="loader-1"><span></span></div>
            </div>
          </div>
        </div>


        <div id="homepageDiscount">
          <div class="ticket">
            <div class="ticket-content">
              <h1>10% OFF</h1>
              <h6 style="margin: 5px 0 15px;">For orders above 10£</h6>
              <p class="bottom">
                <span>Voucher code</span><br>
                V21CU23
              </p>
            </div>
          </div>
        </div>

      </div>
      <div class="mid-bg-separator text-center">
      </div>
    </section>

    <section id="process-overview">
      <div class="ornaments">
        <img src="../../assets/img/plate-delimiter.png" class="plater" alt="Chopstix plate">
        <img src="../../assets/img/lamps-left.png" class="lamps-left" align="Lamps ornaments" />
        <img src="../../assets/img/lamps-right.png" class="lamps-right" align="Lamps ornaments" />
      </div>
      <div class="container">
        <div class="text-center">
          <h2 class="section-title">
            How it works?
          </h2>

          <div class="row">
            <div class="col-md-4 text-center">
              <div class="process">
                <div class="image">
                  <img src="../../assets/img/location-icon.png" alt="Select a Restaurant">
                </div>
                <h4>Select a restaurant</h4>
                <div class="process-step">1</div>
              </div>
            </div>
            <div class="col-md-4 text-center">
              <div class="process">
                <div class="image">
                  <img src="../../assets/img/food-icon.png" alt="Pick a tasty dish">
                </div>
                <h4>Pick a tasty dish</h4>
                <div class="process-step">2</div>
              </div>
            </div>
            <div class="col-md-4 text-center">
              <div class="process">
                <div class="image">
                  <img src="../../assets/img/delivery-icon.png" alt="Get your delivery">
                </div>
                <h4>Collect or deliver to your door</h4>
                <div class="process-step">3</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buildings-separator"></div>
    </section>
    <router-view @getFeaturedProducts="getFeaturedProducts"></router-view>
<!--    <DiscountPopup popupAfterTime="10" v-if="location"></DiscountPopup>-->
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import env from '../../env.json'
  import DiscountPopup from '../../components/discount-popup.vue'

  export default {
    name: 'homepage',
    computed: {
      ...mapState({
        user: state => state.user,
        location: state => state.location,
        cart: state => state.cart
      })
    },
    data () {
      return {
        products: null,
        categories: null,
        selectedCategorySlug: null,
        productsFadeOut: false,
        base_url: env.base_url
      }
    },
    mounted () {
      if (this.location) {
        this.getFeaturedProducts(this.location.id)
      }
    },
    methods: {
      getFeaturedProducts (locationId) {
        this.$store.dispatch('GetFeaturedProductsData', locationId)
          .then(response => {
            this.products = response.products
          })
          .catch(e => {
            console.log(e)
          })
      },
      addToCart: function (title, code, image, productId, price, discount, quantity) {
        let cart = this.cart
        let hasProductInCart = false

        cart.forEach((row) => {
          if (row.id === productId && row.type === 'product') {
            row.quantity = row.quantity + quantity
            hasProductInCart = true
          }
        })

        if (!hasProductInCart) {
          this.cart.push({
            type: 'product',
            id: productId,
            title: title,
            code: code,
            image: image,
            price: price,
            discount: discount,
            quantity: quantity
          })
        }

        this.$store.dispatch('UpdateCart', this.cart)
        this.notifyVue('success', `${quantity} of ${title} has been added to your cart.`)
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    },
    components: {
      DiscountPopup
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// homepage.vue?014812fc